module.exports = __webpack_public_path__ + "static/img/child _porn.1f6e1d9f.png";